import { render, staticRenderFns } from "./DisplayName.vue?vue&type=template&id=e20ec942&scoped=true&"
import script from "./DisplayName.vue?vue&type=script&lang=js&"
export * from "./DisplayName.vue?vue&type=script&lang=js&"
import style0 from "./DisplayName.vue?vue&type=style&index=0&id=e20ec942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ec942",
  null
  
)

export default component.exports